import { baseApi } from '@/services/index'
import { UseOfProceeds } from '@/types/unlock'

export const useOfProceedsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listUseOfProceeds: builder.query<UseOfProceeds[], number>({
      query: (id) => `v2/use-of-proceeds/?application__id=${id}`,
      providesTags: ['UseOfProceeds'],
    }),
  }),
})

export const { useListUseOfProceedsQuery } = useOfProceedsApi
